import React, { useState, useEffect } from "react";
import api from "../../api/axiosConfig";
import './AdminView.css';
import { useLoaderData } from "react-router-dom";
import { useForm } from 'react-hook-form';

export default function Approval() {

    
    const approvedTimesheets = useLoaderData();

    const [timesheets, setTimesheets] = useState(approvedTimesheets);
    useEffect(() => {}, [timesheets]); 
   
    const { register, reset, getValues} = useForm();
    
    const [employeeEmail, setEmployeeEmail] = useState('null');
    const [month, setMonth] = useState();
    const [year, setYear] = useState();

    const availableMonths = [...new Set(approvedTimesheets.map(item => item.month))];

    const availableYears = [...new Set(approvedTimesheets.map(item => item.year))];

    const availableEmployees = [...new Set(approvedTimesheets.map(item => item.employeeEmail))];


    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedEmp, setSelectedEmp] = useState(null);
    
    const getPDF = async({user}) => {
        setEmployeeEmail(user.employeeEmail);
        setMonth(user.month);
        setYear(user.year); 
        
        try{      
            const response = await api.get('/request/'+ employeeEmail + "/" + month + "/" + year);
            var linkSource = `data:application/pdf;base64,${response.data}`;
            const downloadLink = document.createElement("a");
            const fileName = employeeEmail.substring(0, user.employeeEmail.indexOf("@")).toUpperCase().replace(".", " ")+"-"+month+"-"+year;

            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();

            }catch(err){
            console.log(err);
        }
    }
    
    const search = () => {
        var searchMonth = getValues("monthView");
        var searchYear = getValues("yearView");
        var searchEmployee= getValues("empView");

        console.log(searchMonth, searchYear, searchEmployee)

        if(searchMonth!=0&&searchYear==0){
            alert("Please select a year!");
            console.log("1");
        }else if(searchMonth!=0&&searchYear!=0&&searchEmployee!=0){
            setTimesheets(approvedTimesheets.filter((sheet)=>sheet.employeeEmail==searchEmployee&&sheet.month==searchMonth&&sheet.year==searchYear));
            reset({yearView: 0, monthView: 0, empView: 0});
            console.log("2");
        }else if(searchMonth!=0&&searchYear!=0){
            setTimesheets(approvedTimesheets.filter((sheet)=>sheet.month==searchMonth&&sheet.year==searchYear));
            reset({yearView: 0, monthView: 0, empView: 0});
            console.log("3");
        }else if(searchMonth==0&&searchYear!=0){
            setTimesheets(approvedTimesheets.filter((sheet)=>sheet.year==searchYear));
            reset({yearView: 0, monthView: 0, empView: 0});
            console.log("4");
        }else if(searchMonth==0&&searchYear!=0&&searchEmployee!=0){
            setTimesheets(approvedTimesheets.filter((sheet)=>sheet.employeeEmail==searchEmployee&&sheet.year==searchYear));
            reset({yearView: 0, monthView: 0, empView: 0}); 
            console.log("5");
        }else if(searchMonth==0&&searchYear==0&&searchEmployee!=0){
            setTimesheets(approvedTimesheets.filter((sheet)=>sheet.employeeEmail==searchEmployee));
            reset({yearView: 0, monthView: 0, empView: 0}); 
            console.log("6");
        }else if(searchMonth==0&&searchYear==0&&searchEmployee==0){
            alert("Please select a month and year, or an employee name.")
        }
    }

    const refresh = () => {
        window.location.reload();
    }
 
    return(
        <div className="adminView"> 
            <h1 className="adminTitle">iSphere IQ Approved Timesheets</h1>
            <table className="adminTbl">
                <thead className="adminHdr">
                    <tr>
                        <td style={{width:"20%"}}>
                        <select defaultValue={0} {...register("monthView")} onChange={(e) => setSelectedMonth(e.target.value)} >
                            <option value = {0}> MONTH </option>
                            {
                                availableMonths.map(opt=><option value={opt}>{opt.toUpperCase()}</option>)
                            }
                        </select>
                        </td>
                        <td style={{width:"20%"}}>
                        <select defaultValue={0} {...register("yearView")} onChange={(e) => setSelectedYear(e.target.value)} >
                            <option value={0}> YEAR </option>
                            {
                                availableYears.map(opt=><option value={opt}>{opt}</option>)
                                // default curr year
                            }
                        </select>
                        </td>
                        <td style={{width:"35%"}}>
                        <select defaultValue={0} {...register("empView")} onChange={(e) => setSelectedEmp(e.target.value)} >
                            <option value={0}> EMPLOYEE </option>
                            {
                                availableEmployees.map(opt=><option value={opt}>{opt.substring(0, opt.indexOf("@")).toUpperCase().replace(".", " ")}</option>)
                            }
                        </select>
                        </td>
                        <div>
                        <td style={{width:"25%"}}>
                            <input type="button" className="searchBtn" onClick={search} value="Search"/>
                        </td>
                        <td style={{width:"25%"}}>
                            <input type="button" className="refreshBtn" onClick={refresh} value="View All"/>
                        </td>
                        </div>
                    </tr>
                </thead>
                <tbody className="adminBody">
                    {
                    timesheets.map((user, index) => {
                        return <tr key={index}>
                        <td>{user.month}</td>
                        <td>{user.year}</td>
                        <td>{user.employeeEmail.substring(0, user.employeeEmail.indexOf("@")).toUpperCase().replace(".", " ")}</td>
                        <td><button className="downloadBTN" onClick={() => { getPDF({user})}}>Download</button></td>
                        </tr>
                    })
                    }
                </tbody>
            </table>
        </div>
    )
}

export const adminDetailsLoader = async () => {
    const approvedTimesheets = api.get('/request/approved').then( res => res.data);
    return approvedTimesheets;
  }